import { Eye, Pause, Wind, HeartPulse, RotateCcw } from "lucide-react";

const pillars = [
  {
    icon: Eye,
    number: "I",
    title: "Notice",
    body: "See what is here — without flinching, without fixing. The first turning is simply to look.",
  },
  {
    icon: Pause,
    number: "II",
    title: "Pause",
    body: "Stop the forward lean. In the smallest gap between stimulus and response, freedom appears.",
  },
  {
    icon: Wind,
    number: "III",
    title: "Breathe",
    body: "The breath is the doorway. Slow it down and the body remembers how to be here.",
  },
  {
    icon: HeartPulse,
    number: "IV",
    title: "Body",
    body: "Drop from the noise of the mind into the quiet wisdom of the body. It already knows.",
  },
  {
    icon: RotateCcw,
    number: "V",
    title: "Return",
    body: "Come back to yourself, to your values, to this moment. Again, and again, and again.",
  },
];

export default function Pillars() {
  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="relative py-24 md:py-40"
      style={{ backgroundColor: "#EBE8E0" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-4">
            <p className="overline mb-6">03 — Practice</p>
            <h2 className="serif text-4xl md:text-5xl text-[#15243D] leading-[1.1]" style={{ fontWeight: 300 }}>
              Five ways<br />of returning.
            </h2>
          </div>
          <div className="md:col-span-7 md:col-start-6 md:pt-3">
            <p className="text-lg font-light leading-relaxed text-[#5A5D63]">
              The work of Anchor moves through five small practices. Together
              they form a quiet rhythm you can return to in any season — at the
              desk, in the conversation, in the long hour before sleep.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#15243D]/10">
          {pillars.map(({ icon: Icon, number, title, body }, i) => (
            <div
              key={title}
              data-testid={`pillar-card-${i}`}
              className="bg-[#F7F5F0] p-8 md:p-10 group hover:bg-white transition-colors duration-500"
            >
              <div className="flex items-start justify-between mb-10">
                <Icon
                  size={28}
                  strokeWidth={1.25}
                  className="text-[#C07865]"
                />
                <span className="serif text-xl text-[#8A8D93]" style={{ fontWeight: 300 }}>
                  {number}
                </span>
              </div>
              <h3 className="serif text-2xl text-[#15243D] mb-4" style={{ fontWeight: 300 }}>
                {title}
              </h3>
              <p className="text-sm font-light leading-relaxed text-[#5A5D63]">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
